import {
  aiChatModalOpenAtom,
  chatMessagesAtom,
  chatOriginAtom,
  chatSessionIdAtom,
  mealPickerGreetingPendingAtom,
  pendingChatContextAtom,
  pendingChatImageAtom,
  streamInMessageIdAtom,
} from "@/stores/chat.store";
import { clearChatWelcomePending } from "@/utils/chat-welcome-flag";
import { useSetAtom } from "jotai";
import { useCallback } from "react";
import type { HelpFaqItem } from "../constants/help-faq";

export const useOpenHelpChat = () => {
  const setMessages = useSetAtom(chatMessagesAtom);
  const setSessionId = useSetAtom(chatSessionIdAtom);
  const setPendingContext = useSetAtom(pendingChatContextAtom);
  const setPendingImage = useSetAtom(pendingChatImageAtom);
  const setOrigin = useSetAtom(chatOriginAtom);
  const setMealPickerGreetingPending = useSetAtom(mealPickerGreetingPendingAtom);
  const setStreamInMessageId = useSetAtom(streamInMessageIdAtom);
  const openAiChatModal = useSetAtom(aiChatModalOpenAtom);

  return useCallback(
    (item: HelpFaqItem) => {
      const answerId = crypto.randomUUID();
      setMessages([
        { id: crypto.randomUUID(), role: "user", text: item.question },
        { id: answerId, role: "agent", text: item.answer, traceId: null },
      ]);
      setStreamInMessageId(answerId);
      setSessionId(crypto.randomUUID());
      setPendingContext(null);
      setPendingImage([]);
      setOrigin("help");
      setMealPickerGreetingPending(false);
      clearChatWelcomePending();
      openAiChatModal(true);
    },
    [
      setMessages,
      setSessionId,
      setPendingContext,
      setPendingImage,
      setOrigin,
      setMealPickerGreetingPending,
      setStreamInMessageId,
      openAiChatModal,
    ],
  );
};
